export default __webpack_public_path__ + "static/media/company-logo.571bd7cf.gif";